<template>
  <div ref="listContainer" :class="{ correspondants: true, mobile: $parent.mobileMode }" @scroll="onScroll()">
    <MessagerieProfileBox
      ref="result"
      v-for="result in scrollableList.result.list"
      :key="result.profile.id"
      :result="result"
      :updateStatus="true"
      @click="resultClicked"
      @ban="banned"
    />
  </div>
</template>

<script>
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
import { ScrollableList } from "@/assets/js/scrollableList.js";
import MessagerieProfileBox from "@/components/messagerie/MessagerieProfileBox";
import Vue from "vue";

export default {
  name: "ListeCorrespondants",
  components: { MessagerieProfileBox },
  data() {
    return {
      scrollableList: ScrollableList,
      bumpedResult: null
    };
  },

  beforeMount: function() {
    this.scrollableList = new ScrollableList(this.loadFromApi);
  },

  methods: {
    async banned() {
      await Vue.nextTick();
      this.selectFirst();
      if (this.scrollableList.result.list.length == 0) {
        this.$parent.selectedResult = null;
        this.$parent.$refs.listeMessages.scrollableList = { result: { list: [] } };
      }
    },

    resultClicked: function(clickedResult) {
      if (this.$route.query.id != clickedResult.result.profile.id) {
        this.$router.push({
          name: "Messagerie",
          params: { corresp: clickedResult },
          query: { id: clickedResult.result.profile.id }
        });
      }
    },

    selectCorrespondant: async function(result) {
      this.$store.commit("setLoading", true);
      this.$refs.result.forEach(res => {
        res.selected = false;
      });
      if (result) {
        this.$parent.messageView = true;
        this.$parent.selectedResult = result;
        await Vue.nextTick();
        await result.selectResult();
      }
      this.$store.commit("setLoading", false);
    },

    selectFirst: function() {
      if (this.$refs.result && this.$refs.result.length >= 1)
        this.$router.push({
          name: "Messagerie",
          query: { id: this.$refs.result[0].result.profile.id }
        });
    },

    getProfileBox: function(idProfile) {
      let res = null;
      this.$refs.result.forEach(elt => {
        if (elt.result.profile.id === idProfile) res = elt;
      });
      return res;
    },

    init: async function() {
      await this.scrollableList.loadUntilScroll(this.$refs.listContainer);
      await Vue.nextTick();

      if (this.$parent.mobileMode === false && !this.$route.query.id) this.selectFirst();
    },

    loadFromApi: async function(list) {
      const res = await idyuJsonRpc("getCorrespondants", list.result.currentPage);
      if (this.bumpedResult) {
        const ind = res.results.findIndex(elt => elt.profile.id === this.bumpedResult.profile.id);
        if (ind !== -1) res.results.splice(2, 1);
      }
      return res;
    },

    onScroll: function() {
      this.scrollableList.onScroll(this.$refs.listContainer);
    },

    find: function(id) {
      if (!this.$refs.result) {
        return null;
      }
      return this.$refs.result.find(elt => elt.result.profile.id === id);
    },

    insertResult: async function(res) {
      this.scrollableList.result.list.splice(0, 0, res);
      await Vue.nextTick();
    },

    // Result is added when we receive a new message from a profile that was not in the list
    addResult: async function(res) {
      if (!this.$refs.result) return;
      await this.insertResult(res);
      this.$refs.result[this.$refs.result.length - 1].unreadNotLoaded = true;
    },

    // Result is bumped when we send a message to a profile that was not in the list
    // The bumped profil will disappear if we don't send or receive anything

    bumpResult: async function(res) {
      await this.insertResult(res);
      this.bumpedResult = res;
      await this.selectCorrespondant(this.$refs.result[this.$refs.result.length - 1]);
    },

    removeBumped: function() {
      if (this.bumpedResult) {
        const index = this.scrollableList.result.list.findIndex(elt => elt.profile.id === this.bumpedResult.profile.id);
        this.scrollableList.result.list.splice(index, 1);
        if (this.$parent.selectedResult.result.profile.id === this.bumpedResult.profile.id && !this.$route.query.id)
          this.selectFirst();
        this.bumpedResult = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

.correspondants {
  display: grid;
  grid-template-columns: auto;
  width: 350px;
  overflow-y: scroll;
  overflow-x: hidden;
  border-right: $light_border;
  border-bottom: $light_border;
  margin-top: -1px;
  grid-auto-rows: min-content;

  &.mobile {
    width: auto;
    border-right: none;
  }
}
</style>
